<template>
  <button @click="$emit('click');">
    <img
      :src="icon"
      alt="Modal button"
    >
  </button>
</template>

<script>
export default {
  name: 'modal-toggler',
  props: {
    white: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      const icon = require('../../assets/icons/modal.png');
      const iconWhite = require('../../assets/icons/modal-white.png');
      return this.white ? iconWhite : icon;
    },
  },
};
</script>

<style scoped lang="scss">
button {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: none;
  background: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  img {
    display: block;
    width: 18px;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
